angular.module('cfn').directive('dThisViewRequires', function() {
  'use strict';
  return {
    restrict: 'A',
    scope: {
      dThisViewRequires: '='
    },
    template:
      "<div style='margin: 60px auto; background: #fff; max-width: 850px; max-height: 100%; overflow: auto; padding: 20px; border: 1px solid #ddd;'>" +
      "<div ng-repeat='key in showKeys'>{{key | i18n}}</div>" +
      '</div>',
    link: function(scope, elem, attrs) {
      elem.css('display', 'block');
      elem.css('position', 'absolute');
      elem.css('width', '100%');
      elem.css('height', '100%');
      elem.css('background', 'rgba(255,255,255,0.7)');

      scope.$watch('dThisViewRequires.length', function(val) {
        if (!scope.dThisViewRequires) {
          elem.hide();
        } else if (_.isArray(scope.dThisViewRequires)) {
          scope.showKeys = _.chain(scope.dThisViewRequires)
            .filter(function(item) {
              return !item.falseCondition;
            })
            .map(function(item) {
              return item.i18n;
            })
            .value();
          if (scope.showKeys.length === 0) {
            elem.hide();
          } else {
            elem.show();
          }
        } else {
          console.error(
            "dThisViewRequires: input should be an array and have this format: '[{falseCondition: false, i18n:'fe.errormessage'}]",
            val
          );
        }
      });
    }
  };
});

angular.module('cfn').directive('dModalMessage', function() {
  'use strict';
  return {
    restrict: 'EA',
    replace: true,
    transclude: 'element',
    template:
      "<div class='modal-message-overlay' style='" +
      'display: block;' +
      'position: absolute;' +
      'top:0px;' +
      'left:0px;' +
      'width: 100%;' +
      'height: 100%;' +
      'background: rgba(200, 200, 200, 0.7);' +
      "z-index: 10000;'>" +
      "<div class='modal-message-popup' style='" +
      'margin: 60px auto;' +
      'background: #fff;' +
      'max-width: 700px;' +
      'max-height: 100%;' +
      'overflow: auto;' +
      'padding: 20px;' +
      'border: none;' +
      'border-radius: 4px;' +
      "box-shadow: 0 1px 1px rgba(0,0,0,.3),0 2px 10px rgba(0,0,0,.2);'>" +
      '<div ng-transclude></div>' +
      '</div>' +
      '</div>'
  };
});

angular.module('cfn').directive('dScreenMessage', function() {
  'use strict';
  return {
    restrict: 'EA',
    replace: true,
    transclude: 'element',
    template:
      "<div class='modal-message-overlay' style='" +
      'display: flex;' +
      'flex-direction: row;' +
      'position: fixed;' +
      'top:0px;' +
      'left:0px;' +
      'width: 100%;' +
      'height: 100%;' +
      'background: rgba(200, 200, 200, 0.7);' +
      "z-index: 10000;'>" +
      "<div class='modal-message-popup cfn-booking-mask-attachment-modal-message-popup-safari_only' style='" +
      'margin: 6% auto;' +
      'background: #fff;' +
      'width: 50%;' +
      'max-height: 100%;' +
      'padding: 20px;' +
      'border: none;' +
      'border-radius: 4px;' +
      'box-shadow: 0 1px 1px rgba(0,0,0,.3),0 2px 10px rgba(0,0,0,.2);' +
      "overflow: hidden;'>" +
      "<div class='cfn-booking-mask-attachment-modal-container' ng-transclude></div>" +
      '</div>' +
      '</div>'
  };
});

angular.module('cfn').directive('dCopyToClipboard', function() {
  'use strict';
  return {
    restrict: 'E',
    scope: {
      sourceId: '@'
    },
    replace: true,
    template:
      '<div class="clipboard-copy" style="display: flex; flex-direction: column;">' +
      '<a class="btn fn-btn-classic" style="display:inline-block; line-height:29px; white-space: nowrap;" ng-click="copyToClipboard()" ng-show="copySupported">' +
      '{{"fe.booking.attachments.copyToClipBoard" | i18n: "Copy to clipboard"}}</a>' +
      '<span class="coppied-message" style="display: none; font-style: italic;">{{"fe.booking.attachments.contentCopied" | i18n: "... Content copied"}}</span></div>',
    link: function(scope, elem, attrs) {
      scope.copySupported = document.queryCommandSupported('copy');
      scope.copyToClipboard = function() {
        var sourceElem = document.getElementById(scope.sourceId);
        if (!sourceElem) {
          console.error(
            'missing source ' + scope.sourceId + 'for copy-to-clipboard'
          );
          alert("sorry didn't work...");
          scope.copySupported = false;
          return false;
        }
        // must use a temporary form element for the selection and copy
        var target = document.createElement('textarea');
        target.style.display = 'hidden';
        document.body.appendChild(target);
        target.textContent = sourceElem.textContent;

        // select the content
        var currentFocus = document.activeElement;
        target.focus();
        target.setSelectionRange(0, target.value.length);
        // copy the selection
        var succeed;
        try {
          succeed = document.execCommand('copy');
          document.body.removeChild(target);
        } catch (e) {
          succeed = false;
        }
        // restore original focus
        if (currentFocus && typeof currentFocus.focus === 'function') {
          currentFocus.focus();
        }

        if (succeed) {
          $('.clipboard-copy .coppied-message').show();
          $('.clipboard-copy .coppied-message')
            .delay(1000)
            .fadeOut(2000);
        }
        return succeed;
      };
    }
  };
});
